<template>
  <FormValidation @submit="submit" :initData="{ title:'Edit Personal Information', btn:'Edit' }" :formObj="formObj"/>
</template>

<script>
import { mapState } from "vuex";
import { Toast, } from 'mint-ui';
import FormValidation from "../../../../components/app/formValidation";
import { reqMyinfoEditEn } from "../../../../api";
export default {
  components:{
    FormValidation,
  },
  data(){
    return{
      formObj:{}
    }
  },
  beforeMount(){
    this.init()
  },
  methods:{
    async submit(form){
      const response =await reqMyinfoEditEn(form)
      // console.log(response);
      if (response.code*1==2) {
        Toast({position: 'top',message: 'Modified successfully'})
        this.$store.dispatch("userInformation",response.resilt)
        this.$router.push('/user')
      }else{
        Toast({position:'top',message:'Modified failure'})
      }
    },
    init(){
      let {email, name, corpname, country, mobile, } = this.user
      this.formObj={
        email,
        name,
        corpname,
        country,
        mobile,
        duties: "",
        tel: "",
        pwd: "",
        code:''
      }
      console.log('获取',this.formObj);
    }
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
}
</script>

<style scoped>

</style>